import requestApi from "../../../api/request/request";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  sendRequestAgentKitEmail({ state }, { params, callback }) {
    console.log("params: " , params);
    requestApi.sendRequestAgentKitEmailApi({ params, callback }, res => {
      callback(res);
    });
  },

  sendRequestToJoinUConnectEmail({ state }, { params, callback }) {
    requestApi.sendRequestToJoinUConnectEmailApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/request/request.js